import React, { useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import BreakpointContext from "../../contexts/breakpointContext";
import FactoryContext from "../../contexts/factoryContext";
import useHelper from "../../hooks/useHelper";
import useWeek from "../../hooks/queryResults/useWeek";
import styled from "styled-components";
import Loading from "../ui/Loading";
import GameSummaryTeam from "./GameSummaryTeam";

// let color = "#e6eeff";

const StyledDivContainer = styled.div`
  margin: 0.25rem;
  width: ${(props) => props.width};
  min-width: ${(props) => props.minWidth};
`;

const StyledDivGameContainer = styled.div`
  background: ${(props) => (!props.hasStarted ? "#ddd" : "#fff")};
  color: ${(props) => (!props.hasStarted ? "#333" : "#000")};
  cursor: pointer;
`;

const StyledDivVsLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledDivVs = styled.div`
  padding-left: 2rem;
`;

const StyledDivGameStatus = styled.div`
  padding-right: 0.5rem;
  color: ${(props) => props.color};
`;

export default function GameSummary({ game, size }) {
  const history = useHistory();
  const { league, season } = useParams();
  const factory = useContext(FactoryContext);
  const helper = useHelper();
  const { selectedWeek } = useWeek();
  const breakpoints = useContext(BreakpointContext);

  if (!game) return null;

  const loaded = !!helper && factory && selectedWeek;
  if (!loaded) return <Loading />;

  // examples

  if (game.obj.id.substring(0, 3) === "0AZ") {
    game.obj.hasStarted = true;
    game.away.obj.score = 72.32;
    game.away.obj.result = "L";

    game.home.obj.score = 99.13;
    game.home.obj.result = "W";
    game.obj.hasEnded = true;
  } else if (game.obj.id.substring(0, 3) === "XpC") {
    game.obj.hasStarted = true;
    game.obj.hasEnded = false;

    game.away.obj.score = 13.89;
    // game.home.obj.score = 0;
  }

  // handlers

  const handleClick = () => {
    const gameIdOrSlug = `${game.away.team.obj.slug}_${game.home.team.obj.slug}`;
    const week = "wk-" + ("0" + selectedWeek).substr(-2);
    history.push(`/${league}/${season}/${week}/games/${gameIdOrSlug}`);
  };

  // team lines

  const away = (
    <GameSummaryTeam
      game={game}
      gameTeam={game.away}
      size={size}
      isHome={false}
    />
  );
  const home = (
    <GameSummaryTeam
      game={game}
      gameTeam={game.home}
      size={size}
      isHome={true}
    />
  );

  // vs

  let vsLine = null;
  if (size === "lg") {
    const vs = <StyledDivVs>{game.isNeutral ? "vs" : "at"}</StyledDivVs>;

    // todo: add game status "LIVE" for live games
    const gameStatus = game.obj.hasEnded ? (
      <StyledDivGameStatus color={"#999"}>Final</StyledDivGameStatus>
    ) : null;
    vsLine = (
      <StyledDivVsLine>
        {vs}
        {gameStatus}
      </StyledDivVsLine>
    );
  }

  // width

  let width = "7rem";
  let minWidth = width;
  if (size === "lg") {
    minWidth = "10rem";
    if (breakpoints.md) {
      width = "16rem";
    } else if (breakpoints.sm) {
      width = "14.5rem";
    } else {
      width = "12rem";
    }
  }

  const gameName = size === "lg" ? game.obj.name : null;

  return (
    <StyledDivContainer width={width} minWidth={minWidth}>
      {gameName}
      <StyledDivGameContainer
        hasStarted={game.obj.hasStarted}
        onClick={() => handleClick(game)}
      >
        {away}
        {vsLine}
        {home}
      </StyledDivGameContainer>
    </StyledDivContainer>
  );
}
